<template>
  <div class="withdrawal">
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="用户名称">
          <el-input
            style="width: 200px"
            v-model="queryParam.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            clearable
            v-model="queryParam.status"
            placeholder="请选择"
            style="width: 200px"
          >
            <el-option
              v-for="item in statusList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            unlink-panels
            :clearable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="bedata"
            @change="timechange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="primary" @click="clearsearchQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_div">
      <el-table
        :data="withdrawalList"
        border
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        :default-expand-all="false"
        style="width: 100%"
      >
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="wlBusiUserName" label="姓名"></el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="amount" label="提现金额"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.status == '1'"
              >提现成功</span
            >
            <span v-if="scope.row.status == '2'">提现中</span>
            <span style="color: red" v-if="scope.row.status == '3'"
              >提现失败</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="wlBusiUserId" label="商户ID"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间"></el-table-column>
        <el-table-column width="180px" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == '2'"
              size="mini"
              @click="audit('0', scope.$index, scope.row)"
              >通过</el-button
            >
            <el-button
              v-if="scope.row.status == '2'"
              type="danger"
              size="mini"
              @click="audit('-1', scope.$index, scope.row)"
              >拒绝</el-button
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  busiUserwithdrawlist,
  busiUserwithdrawaudit,
} from "@/api/management";
export default {
  name: "withdrawal",
  props: {},
  data() {
    return {
      bedata: "",
      drawer: false,
      title: "新增便利店",
      isQuery: false,
      // 默认显示第几页
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 0,
      // 个数选择器（可修改）
      pageSizes: [10, 20, 30, 40, 100, 200],
      // 默认每页显示的条数（可修改）
      PageSize: 10,
      loading: false,
      statusList: [
        {
          id: "1",
          name: "提现成功",
        },
        {
          id: "2",
          name: "提现中",
        },
        {
          id: "3",
          name: "提现失败",
        },
      ],
      queryParam: {
        name: "",
        start: "",
        end: "",
        status: "",
      },
      options: [],
      withdrawalList: [],
    };
  },
  watch: {},
  computed: {},
  created() {
    var myDate = new Date();
    // 获取 特定日期 之前的 第七天
    let tmpArr = [];
    tmpArr.push(
      moment(myDate.setDate(myDate.getDate() - 7)).format("YYYY-MM-DD HH:mm:ss")
    );
    tmpArr.push(moment(new Date().valueOf()).format("YYYY-MM-DD HH:mm:ss"));
    this.bedata = tmpArr;
    this.queryParam.start = this.bedata[0];
    this.queryParam.end = this.bedata[1];
    this.getwithdrawal();
  },
  methods: {
    timechange(val) {
      console.log(val);
      this.queryParam.start = val[0];
      this.queryParam.end = val[1];
    },
    clearsearchQuery() {
      for (let key in this.queryParam) {
        this.queryParam[key] = "";
      }
      // 默认显示第几页
      this.currentPage = 1;
      this.PageSize = 10;
    },
    audit(num, index, row) {
      let name = num == "0" ? "通过" : "拒绝";
      this.$confirm(`正在执行${name}操作, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        busiUserwithdrawaudit({ id: row.id, status: num }).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.currentPage = 1;
            this.getwithdrawal();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    searchQuery() {
      this.currentPage = 1;
      this.getwithdrawal();
    },
    getwithdrawal() {
      let obj = this.queryParam;
      obj.pageNo = this.currentPage;
      obj.pageSize = this.PageSize;
      busiUserwithdrawlist(obj).then((res) => {
        if (res.code == 200) {
          this.totalCount = res.data.total;
          this.currentPage = res.data.current;
          this.PageSize = res.data.size;
          this.withdrawalList = res.data.records;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val;
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1;
      this.getwithdrawal();
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val;
      this.getwithdrawal();
    },
  },
};
</script>
<style lang="scss" scoped>
.withdrawal {
  padding: 18px;
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
